import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router';
import { FormattedMessage } from 'react-intl';

import Button from 'components/ui/Button';
import { Page, Row, Column } from 'components/shared/Layout';
import { bookingShape } from 'constants/propTypes';
import productTypes from 'constants/productTypes';
import { includesExtraProductOfType, isBookingMultiJourney, isHotelOnly } from 'utils/booking';
import { getBookingAssistanceURL } from 'utils/urls';
import AlertBox from 'components/ui/AlertBox';
import { isEurostarOffer } from 'utils/isEurostarOffer';

import { StyledAddOnsContainer } from './AddOns.styles';
import AddOnLeg from './AddOnLeg';
import { bookingStatus } from 'types/booking';

const AddOns = ({ booking, canAddSpecialAssistanceToBooking, ...props }) => {
  const { reference, outbound, inbound, additionalDetails, displayStatus } = booking || {};

  const history = useHistory();
  const membershipNumber = new URLSearchParams(history.location.search).get('membershipNumber');

  const multiJourneyBooking = isBookingMultiJourney(additionalDetails);
  const hotelOnlyBooking = isHotelOnly(additionalDetails);
  const isVoided = displayStatus === bookingStatus.VOIDED;
  const isBookingUnderpaid = booking.status === bookingStatus.UNDERPAID;

  const shouldBlockAddingAssistance =
    !isEurostarOffer([...outbound, ...inbound]) ||
    !canAddSpecialAssistanceToBooking ||
    hotelOnlyBooking ||
    multiJourneyBooking ||
    isVoided ||
    isBookingUnderpaid;

  return (
    <Page>
      <Row span={14} start={2}>
        <Row>
          <h1>
            <FormattedMessage id="assistance.assistance" />
          </h1>
          <Column style={{ whiteSpace: 'pre-wrap' }}>
            <AlertBox variant={AlertBox.variants.WARNING}>
              <FormattedMessage id="addAssistance.warning" />
            </AlertBox>
            <Button
              data-cy="add-assistance"
              element={<Link to={getBookingAssistanceURL(reference, membershipNumber)} />}
              disabled={shouldBlockAddingAssistance}
            >
              <FormattedMessage id="bookingPath.addAssistance" />
            </Button>
          </Column>
        </Row>
        <Row>
          {includesExtraProductOfType(booking, productTypes.DISABILITY_SUPPORT) ? (
            <StyledAddOnsContainer>
              <Column span={8}>
                <AddOnLeg journey={outbound} direction="outbound" />
              </Column>
              <Column span={8}>
                <AddOnLeg journey={inbound} direction="inbound" />
              </Column>
            </StyledAddOnsContainer>
          ) : (
            <Column>
              <FormattedMessage id="assistance.noSpecialProducts" />
            </Column>
          )}
        </Row>
      </Row>
    </Page>
  );
};

AddOns.propTypes = {
  booking: bookingShape,
  canAddSpecialAssistanceToBooking: PropTypes.bool.isRequired
};

export default AddOns;
